<template>
    <div class="a-modal a-modal--relative">
<!--        <div class="popup__header">-->
<!--        </div>-->
<!--        @slideChange="carouselCount($event)"-->
        <swiper v-if="currentAlbum" class="memory__gallery" ref="swiper" :options="swiperOption">
            <swiper-slide class="memory__gallery-slide"
                v-for="(photo, index) in currentAlbum.photos" :key="index">
                    <div class="memory__gallery-slide__inner">
                        <img :data-src="photo.url" class="swiper-lazy memory__gallery-slide__bg">
                        <img class="swiper-lazy memory__gallery-slide__img"
                            :data-src="photo.url">
                        <div class="swiper-lazy-preloader"></div>
                    </div>
                    <div v-if="photo.title" class="memory__gallery-slide__desc">
                        {{ photo.title }}
                    </div>
            </swiper-slide>

        </swiper>
        <div class="memory__gallery-control memory__gallery-control--prev"
             @click.prevent="$refs.swiper.$swiper.slidePrev()">
            <img src="/assets/front/img/icons/icon-arrow.svg" alt="prev" class="memory__gallery-control__icon memory__gallery-control__icon--prev">
        </div>
        <div class="memory__gallery-control memory__gallery-control--next"
             @click.prevent="$refs.swiper.$swiper.slideNext()">
            <img src="/assets/front/img/icons/icon-arrow.svg" alt="next" class="memory__gallery-control__icon memory__gallery-control__icon--next">
        </div>
    </div>
</template>

<script>
import memories from "../../mixins/memories";
import ApiService from "../../api/api";

export default {
    name: 'MemoriesPageAlbum',
    mixins: [memories],
    props: {
        album: {
            type: Object,
            default: null
        },
        preview: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            count: 1,
            currentAlbum: this.album,
            swiperOption: {
                lazy: true,
                spaceBetween: 30,
                on: {
                    lazyImageReady: function (swiper, slideEl, imageEl) {
                        if (imageEl.classList.contains('memory__gallery-slide__img') && imageEl.naturalWidth > imageEl.naturalHeight) {
                            imageEl.classList.add('memory__gallery-slide__img--horizontal')
                        }
                        if (imageEl.classList.contains('memory__gallery-slide__img') && imageEl.naturalHeight >= imageEl.naturalWidth) {
                            imageEl.classList.add('memory__gallery-slide__img--vertical')
                        }
                    }
                }
            },
        }
    },
    mounted() {
        if (this.album) {
            this.currentAlbum = this.album;
        } else if (!this.preview) {
            ApiService.get('/profile/' + this.$route.params.slug).then((response) => {
                let albums = this.convertArrayToGallery(response.data.gallery);

                this.currentAlbum = albums.find(album => album.uuid == this.$route.params.id);
            });
        }
    }
}
</script>
